// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__OYE4F","colMin":"styles_colMin__2QRoa"};